import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const LibraryPickerDialog = ({
  open, onOpenChange, libQuery, setLibQuery, loadLibrary,
  libItems, suggestions, people, onPick,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-3xl" data-testid="library-picker-dialog">
      <DialogHeader><DialogTitle>Biblioteca de imágenes</DialogTitle></DialogHeader>
      <div className="flex gap-2 mb-3">
        <Input placeholder="Buscar por nombre, pie o etiqueta" value={libQuery}
               onChange={(e) => setLibQuery(e.target.value)}
               onKeyDown={(e) => e.key === "Enter" && loadLibrary()}
               data-testid="library-picker-search" />
        <Button variant="outline" onClick={loadLibrary} data-testid="library-picker-search-btn">
          Buscar
        </Button>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 max-h-[55vh] overflow-y-auto">
        {suggestions.length > 0 && (
          <div className="col-span-full" data-testid="library-suggestions">
            <p className="text-xs uppercase tracking-wider text-primary mb-2">
              Protagonistas de esta nota{people.length ? `: ${people.slice(0, 4).join(", ")}` : ""}
            </p>
            <div className="grid grid-cols-3 sm:grid-cols-4 gap-3">
              {suggestions.map((it) => (
                <button key={`s-${it.id}`} onClick={() => onPick(it)}
                        className="border border-primary/60 hover:border-primary text-left"
                        data-testid={`library-suggestion-${it.id}`}>
                  <img src={it.url} alt="" className="w-full aspect-[4/3] object-cover bg-muted" />
                  <span className="block p-1.5 text-[11px] truncate">{it.match}</span>
                </button>
              ))}
            </div>
          </div>
        )}
        {libItems.map((it) => (
          <button key={it.id} onClick={() => onPick(it)}
                  className="border border-border hover:border-primary text-left"
                  data-testid={`library-pick-${it.id}`}>
            <img src={it.url} alt="" className="w-full aspect-[4/3] object-cover bg-muted" />
            <span className="block p-1.5 text-[11px] truncate">{it.name}</span>
          </button>
        ))}
        {!libItems.length && (
          <p className="col-span-full text-sm text-muted-foreground py-6 text-center">
            No hay imágenes en la biblioteca con ese criterio.
          </p>
        )}
      </div>
    </DialogContent>
  </Dialog>
);

const FIELDS = [
  ["title", "Título", "image-meta-title"],
  ["alt_text", "Texto alternativo (alt)", "image-meta-alt"],
  ["caption", "Leyenda / pie", "image-meta-caption"],
];

export const ImageMetaDialog = ({ meta, setMeta, onSave }) => (
  <Dialog open={!!meta} onOpenChange={(o) => !o && setMeta(null)}>
    <DialogContent className="grid-cols-1 max-w-lg" data-testid="image-meta-dialog">
      <DialogHeader><DialogTitle>Datos de la imagen para WordPress</DialogTitle></DialogHeader>
      {meta && (
        <div className="space-y-3">
          <img src={meta.url} alt="" className="w-full max-h-48 object-contain bg-muted" />
          {FIELDS.map(([key, label, testid]) => (
            <div key={key}>
              <Label className="text-xs uppercase tracking-wider">{label}</Label>
              <Input value={meta[key]} onChange={(e) => setMeta({ ...meta, [key]: e.target.value })}
                     className="mt-1.5" data-testid={testid} />
            </div>
          ))}
          <div>
            <Label className="text-xs uppercase tracking-wider">Descripción</Label>
            <Textarea rows={2} value={meta.description}
                      onChange={(e) => setMeta({ ...meta, description: e.target.value })}
                      className="mt-1.5" data-testid="image-meta-description" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider">Crédito o fuente</Label>
            <Input value={meta.credit} onChange={(e) => setMeta({ ...meta, credit: e.target.value })}
                   className="mt-1.5" data-testid="image-meta-credit" />
          </div>
          <Button onClick={onSave} className="w-full" data-testid="image-meta-save">
            Guardar datos
          </Button>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
